/**
 * Breadcrumb navigation component for admin page.
 * Shows hierarchical navigation path (Class > Family > Genus > Flair).
 */
import { Box, Chip, Typography } from '@mui/material';
import { useAdminContext } from '../AdminContext';

export default function Breadcrumbs() {
  const context = useAdminContext();
  const {
    selectedClass,
    selectedFamily,
    selectedGenus,
    selectedFlair,
    setSelectedClass,
    setSelectedFamily,
    setSelectedGenus,
    setSelectedFlair,
    setActiveTab,
    activeTab,
  } = context;

  if (!selectedClass && !selectedFamily && !selectedGenus && !selectedFlair) {
    return null;
  }

  const handleClearFilters = () => {
    setSelectedClass(null);
    setSelectedFamily(null);
    setSelectedGenus(null);
    setSelectedFlair(null);
    if (setActiveTab && (activeTab === 'family' || activeTab === 'genus' || activeTab === 'flair' || activeTab === 'image')) {
      setActiveTab('class');
    }
  };

  return (
    <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
      <Chip
        label="All"
        onClick={handleClearFilters}
        color={!selectedClass ? 'primary' : 'default'}
        size="small"
      />
      {selectedClass && (
        <>
          <Typography>/</Typography>
          <Chip
            label={selectedClass}
            onClick={() => {
              setSelectedClass(null);
              setSelectedFamily(null);
              setSelectedGenus(null);
              setSelectedFlair(null);
              setActiveTab?.('class');
            }}
            color={selectedClass && !selectedFamily ? 'primary' : 'default'}
            size="small"
          />
        </>
      )}
      {selectedFamily && (
        <>
          <Typography>/</Typography>
          <Chip
            label={selectedFamily}
            onClick={() => {
              setSelectedFamily(null);
              setSelectedGenus(null);
              setSelectedFlair(null);
              setActiveTab?.('family');
            }}
            color={selectedFamily && !selectedGenus ? 'primary' : 'default'}
            size="small"
          />
        </>
      )}
      {selectedGenus && (
        <>
          <Typography>/</Typography>
          <Chip
            label={selectedGenus}
            onClick={() => {
              setSelectedGenus(null);
              setSelectedFlair(null);
              setActiveTab?.('genus');
            }}
            color={selectedGenus && !selectedFlair ? 'primary' : 'default'}
            size="small"
          />
        </>
      )}
      {selectedFlair && (
        <>
          <Typography>/</Typography>
          <Chip
            label={selectedFlair}
            onClick={() => {
              setSelectedFlair(null);
              setActiveTab?.('flair');
            }}
            color="primary"
            size="small"
          />
        </>
      )}
    </Box>
  );
}
